import { useEventCallback } from '@material-ui/core/utils';

// Returns a function with a permanently stable identity that always calls the latest version of
// `callback`. This is Material-UI v4's own useEventCallback - its shipped type declaration is just
// `(...args: any[]) => void`, so it is re-typed here to preserve the wrapped function's signature.
//
// For handlers invoked from events / validators only. Do not call the result during render: it
// points at the newest callback once the render that created it has committed.
export const useStableCallback = useEventCallback as unknown as <
    // tslint:disable-next-line: no-any
    Callback extends (...args: any[]) => any
>(callback: Callback) => Callback;
